
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#eaeaea","d":"M30.4 16c0 7.953-6.447 14.4-14.4 14.4S1.6 23.953 1.6 16 8.047 1.6 16 1.6 30.4 8.047 30.4 16z"}}),_c('path',{attrs:{"fill":"#55565a","d":"M16.259 7.389a3.99 3.99 0 011.164-.905 3.395 3.395 0 011.382-.404c.022.101.028.218.028.337 0 .411-.073.806-.207 1.171a4.156 4.156 0 01-.719 1.258 3.648 3.648 0 01-1.124.897 2.737 2.737 0 01-1.454.318c-.004-.1-.011-.216-.011-.334 0-.408.081-.797.227-1.152a4.1 4.1 0 01.719-1.192zm4.968 13.825a8.808 8.808 0 01-1.156 1.449 2.219 2.219 0 01-1.494.673 3.025 3.025 0 01-1.394-.342 3.362 3.362 0 00-1.477-.343 3.567 3.567 0 00-1.532.346 3.417 3.417 0 01-1.303.36 2.135 2.135 0 01-1.535-.682 9.483 9.483 0 01-1.195-1.469 10.867 10.867 0 01-1.695-4.134 6.974 6.974 0 01-.171-1.53c0-1.124.276-2.183.763-3.115a4.442 4.442 0 011.491-1.52 4.087 4.087 0 012.079-.61c.585.02 1.131.154 1.626.379.342.173.769.308 1.22.37a5.14 5.14 0 001.466-.459 4.19 4.19 0 011.89-.331c.506.025.99.135 1.436.318a3.851 3.851 0 011.721 1.381c-.368.249-.69.528-.963.851a3.647 3.647 0 00-.904 2.407v.047-.001.039c0 1.058.447 2.011 1.162 2.682a3.92 3.92 0 001.143.764c-.077.337-.177.6-.29.857a9.583 9.583 0 01-.909 1.643z"}})])
          )
        }
      }
    